import React, { useState, useEffect, } from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Helmet } from "react-helmet";
import Footer from 'components/Footer/Footer';
import './style.css';
//import CityImage from 'Assets/city-hero.png';
import UpcomingEvents from 'components/UpcomingEvents/UpcomingEvents';
//import Trending from "components/TrendingNow/Trending";
import PresentationCard from "components/PresentationCard/PresentationCard";
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner'
import website from 'Assets/website.svg';
import facebook from 'Assets/facebook.svg';
import twitter from 'Assets/twitter.svg';
import linkedin from 'Assets/linkedin.svg';
import noEventImg from 'Assets/noEventImage.svg';
import noPkImage from 'Assets/noPkImage.svg';
import { Redirect } from 'react-router-dom';
import { user_friendly_url, myHeaders_Auth_With_Cache_Control, user_Status, apiUrl, user_entity_uuid, organization_user_access_level, org_friendly_url, user_API, user_access_level, myHeaders_Autorized } from 'Api/Api';
import axios from 'axios';
import avatar from 'Assets/avatarnew.svg';
import { get_current_unix_stamp, dateConvert, unixDateConversion, DaysDiff, HoursDiff } from 'utils/Helper';
import { local_routes } from 'utils/Routes';
import home from 'Assets/home.svg';

import FollowButton from 'components/FollowButton/FollowButton';
import TipButton from 'components/TipButton/TipButton';
// import ChatCallButton from 'components/ChatCallButton/ChatCallButton';


function Profile(props) {
    const [followed, setFollowed] = useState(false);
    const [is_active, setIsActive] = useState(false);
    const [friended, setFriended] = useState(false);
    const [tipped, setTipped] = useState(false);
    const [friendly_url, setFriendly_url] = useState(null);
    const [isLoader, setIsLoader] = useState(true);
    const [userInfo, setUserInfo] = useState({});
    const [userPk, setUserPk] = useState([]);
    const [userEvents, setUserEvents] = useState([]);
    const [redirect, setRedirect] = useState(false)
    const [TrendingImg, setTrendingImg] = useState(null);
    const [page_title, setPageTitle] = useState("PechaKucha User Profile");

    let workspace_base_url = "";
    //let coverImg;
    //const { match: { params: { org_friendly_url } = {} } = {} } = props;
    if (org_friendly_url) {
      workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
    }
    
    // unmount
    useEffect(() => {
      return () => {
        console.log("cleaned up");
      };
    }, []);

    useEffect(() => {
        if (props.match.params.friendly_url !== undefined) {
            setFriendly_url(props.match.params.friendly_url)
            let recFriendlyUrl = props.match.params.friendly_url;
            setIsLoader(true);
       
            let api_promises = [
                axios.get(`${user_API}/${recFriendlyUrl}`, (user_Status === 1 ? myHeaders_Auth_With_Cache_Control : {})),
                axios.get(`${user_API}/${recFriendlyUrl}/presentations?do_recursive=true&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}&filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}&limit=40`, myHeaders_Autorized),
                axios.get(`${user_API}/${recFriendlyUrl}/events?sort_obj=${encodeURIComponent('{"start_time":"desc"}')}&limit=40`, myHeaders_Autorized),// peter-exley-4
            ];
            
            
            if (user_Status === 1) {
                api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/users.audience/${recFriendlyUrl}`, myHeaders_Auth_With_Cache_Control));
            }  
            
            
            Promise.all(api_promises)
                .then(([userDataRes, userPkRes, userEventsRes, favorited_result]) => {
                    if (favorited_result && favorited_result.data) {
                      if (favorited_result.data.favorited_time && favorited_result.data.favorited_time > 0) {
                        setFollowed(true);
                      }
                      if (favorited_result.data.tips && favorited_result.data.tips.length > 0) {
                        setTipped(true);
                      }
                      if (favorited_result.data.friended_time && favorited_result.data.friended_time > 0) {
                        //console.log("FRIENDED",userDataRes.data.last_active_time,get_current_unix_stamp());
                        setFriended(true);
                        if (userDataRes.data.last_active_time && userDataRes.data.last_active_time > get_current_unix_stamp() - 900) {
                          //console.log("ACTIVE");
                          setIsActive(true);
                        }
                      }
                    }
                    if (userDataRes.data) {
                        let userResp = userDataRes.data;
                        
                        // make sure this is not a public request for a private profile
                        //if (!workspace_base_url) {
                        //    if (userResp.public_status && userResp.public_status !== 'public') {
                        //        setRedirect(true);
                        //    }
                        //}
                        
                        userResp.short_nickname = "";
                        if (userResp.firstname) {
                            userResp.short_nickname = userResp.firstname;
                        } else if (userResp.lastname) {
                            userResp.short_nickname = userResp.lastname;
                        } else {
                            userResp.short_nickname = "PechaKucha Fan";
                            userResp.lastname = "";
                        }
                        
                        if (userResp.public_status && userResp.public_status !== 'public') {
                            let allowed = false;
                            if (user_access_level === 'admin') {
                                allowed = true;
                            } else if (workspace_base_url && organization_user_access_level === 'admin') {
                                allowed = true;
                            } else if (user_entity_uuid === userResp.entity_uuid) {
                                allowed = true;
                            }
                            if (allowed) {
                                userResp.lastname = <span>{userResp.lastname}<span style={{ verticalAlign: "super", fontSize: "x-small", color: "#E50114" }}> PRIVATE</span></span>;
                            } else {
                                setRedirect(true)
                            }
                        }
                        
                        if (userResp.avatar_image_url) {
                            let url = userResp.avatar_image_url;
                            let array = url.split("/");
                            userResp.avatar_image_url_updated =`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_125x125/${array[5]}` 
                        }             
                        setUserInfo(userResp);
                        //console.log("USER",userResp);
                        let coverImg;
                        if (userResp.cover_image_url !== undefined && userResp.cover_image_url !== null) {
                            let url = userResp.cover_image_url;
                            let array = url.split("/");
                            coverImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1300x360/${array[5]}`
                        } else if (userResp.cover_image_url_url !== undefined && userResp.cover_image_url_url !== null) {
                            // there was a bug in API and Account Settings that caused cover_image_url_url to happen
                            let url = userResp.cover_image_url_url;
                            let array = url.split("/");
                            coverImg = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_1300x360/${array[5]}`
                        }
                        //console.log("COVER IMAGE",coverImg);
                        setTrendingImg(coverImg);
                        
                        if (userResp.firstname && userResp.lastname) {
                            userResp.full_name = userResp.firstname+' '+userResp.lastname;
                        } else if (userResp.lastname) {
                            userResp.full_name = userResp.lastname;
                        } else if (userResp.firstname) {
                            userResp.full_name = userResp.firstname;
                        } else {
                            userResp.full_name = 'Unknown';
                        }
                    
                        //setPageTitle(userResp.full_name+' PechaKucha User Profile');
                        setPageTitle(userResp.full_name+' Presentations & 20x20 Pecha Kuchas');
                    } else {
                        setIsLoader(false);
                    }
                    
                    if (userPkRes.data.length > 0) {
                        let pkTempArr = []; let pkFilteredArr = [];
                        userPkRes.data.forEach((item) => {
                            if (item.status_code === 1) {
                                //item.users = [userDataRes.data];
                                pkTempArr.push(item)
                            }
                        })
                        pkTempArr.forEach((filteredItem) => {
                                pkFilteredArr.push(filteredItem)
                        })
                        setUserPk(pkFilteredArr)
                    } else {
                        setIsLoader(false);
                        setUserPk([])
                    }

                    if (userEventsRes.data.length > 0) {
                        const eventsArray = []
                        let start_time, start_time_conv;

                        userEventsRes.data.forEach(function (entity_data, index) {
                            start_time = unixDateConversion(entity_data.start_time);
                            start_time_conv = dateConvert(start_time)
                            let time_slot = start_time_conv.hour;
                            var selectedDate = start_time;                            
                            
                            let days_left;
                            if (selectedDate && selectedDate > new Date()) {
                                let day_diff = DaysDiff(start_time);
                                let hour_diff = HoursDiff(start_time);
                                days_left = "Starts in " + day_diff + " days, " + hour_diff + " hours";
                             } else {
                                days_left = "Completed";
                             }
                            
                            //let day_diff = DaysDiff(start_time);
                            //let hour_diff = HoursDiff(start_time);
                            //days_left = day_diff > 0 ? "Starts in " + day_diff + " days, " + hour_diff + " hours" : "Completed Event";
                            eventsArray[index] = ({
                                entity_name: entity_data.entity_name,
                                friendly_url: entity_data.friendly_url,
                                entity_uuid: entity_data.entity_uuid,
                                event_days_left: days_left,
                                thumb_image_url: entity_data.thumb_image_url || null,
                                poster_image_url: entity_data.poster_image_url,
                                locations_text: entity_data.locations_text,
                                Event_month: start_time_conv.month,
                                Event_year: start_time_conv.year,
                                Event_day: start_time_conv.day,
                                Event_date: start_time_conv.date,
                                Event_slot: time_slot,
                                volume_integer: entity_data.volume_integer
                            });
                        })

                        setUserEvents(eventsArray)
                        setIsLoader(false)
                    } else {
                        setIsLoader(false);
                        setUserEvents([]);
                    }
                });
        }
        else setRedirect(true)
    }, [props.match.params.friendly_url])

    if (redirect) {
        return <Redirect to='/404' />;
    }
    else if (isLoader === true) {
        return (
            <FullPageSpinner />
        )
    }
    else {
        return (
            <React.Fragment>
                <Helmet defer={false}>
                    <title>{page_title}</title>
                </Helmet>
                <div className="main-section">
                    
                    <div className="profile-section" style={{ paddingTop: TrendingImg ? 0 : 50 }}>
                        <div className="profile-banner" style={{ display: TrendingImg ? null : 'none' }} >
                            <img src={TrendingImg || null} className="city-img img-fluid" alt="City" />
                        </div>
                        <div className="container">
                            <Row>
                                <Col sm={12} md={5} lg={4}>
                                    <div style={{ marginTop: TrendingImg ? -150 : 0 }}>
                                        <div className={TrendingImg ? "profile-info" : 'profile-info1'}>
                                            <div className="profile-img">
                                                <img src={userInfo.avatar_image_url_updated ? userInfo.avatar_image_url_updated : avatar} alt="img" className="profileimg" />
                                            </div>
                                            <div className="profile-det">
                                                <h4>
                                                  {userInfo.firstname} {userInfo.lastname}
                                                    { friended &&
                                                      <span data-tip="Mutual friends" style={{ fontSize: "smaller", marginLeft: "5px" }}><i className="fa fa-handshake-o" aria-hidden="true"></i>&nbsp;</span>
                                                    }
                                                    { tipped &&
                                                      <span data-tip="You are a tipper and a patron! Thank you!" style={{ color: 'gold', fontSize: "smaller", marginLeft: "5px" }}><i className="fa fa-star" aria-hidden="true"></i>&nbsp;</span>
                                                    }
                                                </h4>
                                                <div className="social-icons">
                                                    {
                                                        userInfo.twitter_handle &&
                                                        <a target="_blank"  href={`https://www.twitter.com/${userInfo.twitter_handle}`} rel="noopener noreferrer"><img src={twitter} alt="img" /></a>
                                                    }
                                                    {
                                                        userInfo.facebook_handle &&
                                                        <a target="_blank"  href={`https://www.facebook.com/${userInfo.facebook_handle}`} rel="noopener noreferrer"><img src={facebook} alt="img" /></a>
                                                    }
                                                    {
                                                        userInfo.linkedin_handle &&
                                                        <a target="_blank"  href={`https://www.linkedin.com/in/${userInfo.linkedin_handle}`} rel="noopener noreferrer"><img src={linkedin} alt="img" /></a>
                                                    }
                                                    {
                                                        user_access_level.endsWith('admin') && userInfo.website_url &&
                                                        <a target="_blank"  href={userInfo.website_url} rel="noopener noreferrer"><img src={website} alt="img"  /></a>
                                                    }
                                                    <br/>
                                                    { friendly_url !== user_friendly_url &&
                                                      <div style={{ paddingTop: "5px" }}>
                                                          <FollowButton
                                                            entity_info={{entity_type: 'users', ...userInfo}}
                                                            followed={followed}
                                                            friendsOrNot={(are_we_friends) => {setFriended(are_we_friends)}}
                                                          />
                                                          { (user_access_level === 'admin' && (userInfo.access_level === 'admin' || userInfo.account_level === 'private')) &&
                                                            <TipButton
                                                              style={{ marginLeft: '5px' }}
                                                              entity_info={{entity_type: 'users', ...userInfo}}
                                                            />
                                                          }
                                                          {/*
                                                          &nbsp;
                                                          { (friended && is_active) &&
                                                            <ChatCallButton
                                                              entity_info={{entity_type: 'users', ...userInfo}}
                                                            />
                                                          }
                                                          */}
                                                      </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="profile-about">
                                            <h5>About {userInfo.short_nickname}</h5>
                                            {userInfo.description !== undefined &&
                                                <div className="panel-wrapper">
                                                    <a href="#show" className="show btn" id="show">Show Full Description</a>
                                                    <a href="#hide" className="hide btn" id="hide">Hide Full Description</a>
                                                    <p className="panel">
                                                        {userInfo.description !== undefined && !null ? userInfo.description : ''}
                                                    </p>
                                                    <div className="fade"></div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12} md={7} lg={8}>
                                        <div className="profileAllData">
                                        { (userPk.length > 0 || userEvents.length === 0) &&
                                            <React.Fragment>
                                            <div className="profile-head">
                                                <h1>{userInfo.short_nickname}'s Recent Presentations</h1>
                                            </div>
                                            <div className="profileDetail">
                                                <Row>
                                                    { userPk.length > 0 ?
                                                        <React.Fragment>
                                                            {userPk.map(item => (
                                                                <Col key={item.entity_uuid} lg={6}>
                                                                    <PresentationCard
                                                                        key={item.entity_uuid}
                                                                        presentation_info={item}
                                                                    />
                                                                    {/*
                                                                    <Trending
                                                                        key={item.id}
                                                                        Trending_now_title={item.entity_name}
                                                                        Trending_now_text={item['description']}
                                                                        Trending_img={item.image_url}
                                                                        Trending_link={`${workspace_base_url}${local_routes.presentations}/${item.friendly_url}`}
                                                                    />
                                                                    */}
                                                                </Col>
                                                            ))}
                                                        </React.Fragment>
                                                        :
                                                        <div className="pk-placeHolder-Section" style={{
                                                            paddingLeft: noEventImg ? 17 : 0,
                                                            paddingRight: noEventImg ? 17 : 0
                                                        }}>
                                                            <p>{userInfo.short_nickname} has no presentations ... yet!</p>
                                                            <img src={noPkImage} alt="img" className="img-fluid" />
                                                        </div>
                                                    }
                                                </Row>
                                            </div>
                                            </React.Fragment>
                                        }
                                        <div className="profile-head">
                                            <h1>{userInfo.short_nickname}'s Recent Events</h1>
                                        </div>
                                        <div className="profileDetail">
                                            <Row>
                                                {
                                                    userEvents.length > 0
                                                        ?
                                                        <React.Fragment>
                                                            {
                                                                userEvents.map((item) =>
                                                                    <Col lg={6} key={item.entity_uuid}>
                                                                        <UpcomingEvents
                                                                            key={item.entity_uuid}
                                                                            Event_month={item.Event_month}
                                                                            Event_date={item.Event_date}
                                                                            Event_vol={item.Event_vol}
                                                                            Event_slot={item.Event_slot}
                                                                            Event_img={item.thumb_image_url || item.poster_image_url}
                                                                            Event_time={item.event_days_left}
                                                                            Event_place={item.locations_text}
                                                                            Event_title={item.entity_name}
                                                                            Event_year={item.Event_year}
                                                                            Event_link={`${workspace_base_url}${local_routes.events}/${item.friendly_url}`}
                                                                        />
                                                                    </Col>
                                                                )}
                                                        </React.Fragment>
                                                        :
                                                        <div className="event-placeHolder-Section" style={{
                                                            paddingLeft: noEventImg ? 17 : 0,
                                                            paddingRight: noEventImg ? 17 : 0
                                                        }}>
                                                            <p>{userInfo.short_nickname} has not presented ... yet!</p>
                                                            <img src={noEventImg} alt="img" className="img-fluid" />
                                                        </div>
                                                }
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <Footer 
                    homeImg={home}
                    homeImgRef="/" 
                    breadcrumbSubPage="Profile"
                    />
                </div>
            </React.Fragment>
        )
    }

}
export default Profile;